import controller from './brands.controller';
import templateBase from './templates/brands-base.view.html';
import templateT1 from './templates/brands-t1.view.html';
import templateT3 from './templates/brands-t3.view.html';
import templateT4 from './templates/brands-t4.view.html';

let BrandsComponent = {
  template: changeTemplate,
  controller,
  bindings: {
    shCtrl: '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');
 if(response.BRANDS.component == 'template_t1'){
  return templateT1
 } else if(response.BRANDS.component == 'template_t3'){
   return templateT3
 } else if(response.BRANDS.component == 'template_t4'){
     return templateT4
 } else {
  return templateBase;
 }
}

export default BrandsComponent;




/** WEBPACK FOOTER **
 ** ./www/components/home/brands/brands.component.js
 **/